(() => {
  const init = (root) => {
    if (root.dataset.enhanced) return;
    const tabs = [...root.querySelectorAll('[data-lq-tab]')];
    const panels = [...root.querySelectorAll('[data-lq-panel]')];
    const choose = (tab, focus = false) => {
      tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; });
      panels.forEach(p => { p.hidden = p.dataset.lqPanel !== tab.dataset.lqTab; });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => choose(tab));
      tab.addEventListener('keydown', e => {
        let n;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        else return;
        e.preventDefault(); choose(tabs[n], true);
      });
    });
    panels.forEach(p => { p.setAttribute('role','tabpanel'); p.setAttribute('aria-labelledby', tabs.find(t => t.dataset.lqTab === p.dataset.lqPanel).id); });
    if (tabs.length) { root.querySelector('[data-lq-tabs]').hidden = false; choose(tabs[0]); }
    const theater = root.querySelector('[data-lq-theater]');
    const player = root.querySelector('[data-lq-player]');
    const cards = [...root.querySelectorAll('[data-lq-film]')];
    let activeCard;
    cards.forEach(card => card.addEventListener('click', e => {
      const id = card.dataset.videoId;
      if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
      e.preventDefault();
      activeCard = card;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      frame.title = card.dataset.videoTitle;
      frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      player.replaceChildren(frame);
      root.querySelector('[data-lq-player-title]').textContent = card.dataset.videoTitle;
      theater.hidden = false;
      cards.forEach(c => c.setAttribute('aria-current', String(c === card)));
      theater.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'nearest'});
      root.querySelector('[data-lq-stop]').focus({preventScroll:true});
    }));
    root.querySelector('[data-lq-stop]').addEventListener('click', () => {
      player.replaceChildren(); theater.hidden = true;
      cards.forEach(c => c.removeAttribute('aria-current'));
      if (activeCard) activeCard.focus({preventScroll:true});
    });
    root.dataset.enhanced = 'true';
  };
  const start = (container = document) => container.querySelectorAll('[data-lq-hub]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once:true}); else start();
  document.addEventListener('shopify:section:load', e => start(e.target));
})();

